module.exports = __webpack_public_path__ + "img/loginPageBackground.1cafa7e1.svg";